import * as Yup from 'yup';
import { nameRequired, stringOptional, stringRequired } from '.';

export const smsAutomationSchema = Yup.object({
    action_name: nameRequired,
    message: stringRequired
});

export const emailAutomationSchema = Yup.object({
    action_name: nameRequired,
    subject: stringOptional,
    message: Yup.string().test(
            'is-not-empty',
            'Message is required',
            (value) => {
                if (typeof value !== 'string') return false;
                return value.replace(/<(?:.|\n)*?>/gu, '').trim().length > 0;
            }
        )
});

export const emailSubjectAutomationSchema = Yup.object({
    action_name: nameRequired,
    subject: stringRequired,
    message: Yup.string().test(
            'is-not-empty',
            'Message is required',
            (value) => {
                if (typeof value !== 'string') return false;
                return value.replace(/<(?:.|\n)*?>/gu, '').trim().length > 0;
            }
        )
});


export const timerAutomationSchema = Yup.object({
    duration: Yup.number()
        .integer('Must be a whole number')
        .moreThan(0, 'Must be greater than 0')
        .max(1000, 'Must be 1000 or less')
        .required('Value Required')
});

export const conditionAutomationSchema = Yup.object({
    action_name: stringRequired,
    trigger: Yup.object().shape({
        type: Yup.string().required('Trigger type is required'),
        emailReference: Yup.string().when('type', {
            is: (type: string) => type !== 'deal',
            then: (schema) => schema.required('Email reference is required'),
            otherwise: (schema) => schema.notRequired()
        })
    })
});